import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePinInputClass;
function SavePinInput() {
  if (SavePinInputClass === VOID) {
    class $ {
      constructor(partyId, pinId, icon, name) {
        this.i6o_1 = partyId;
        this.j6o_1 = pinId;
        this.k6o_1 = icon;
        this.l6o_1 = name;
      }
      toString() {
        return 'SavePinInput(partyId=' + this.i6o_1.toString() + ', pinId=' + this.j6o_1.toString() + ', icon=' + this.k6o_1 + ', name=' + this.l6o_1 + ')';
      }
      hashCode() {
        var result = this.i6o_1.hashCode();
        result = imul(result, 31) + this.j6o_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.k6o_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.l6o_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePinInput()))
          return false;
        if (!this.i6o_1.equals(other.i6o_1))
          return false;
        if (!this.j6o_1.equals(other.j6o_1))
          return false;
        if (!(this.k6o_1 === other.k6o_1))
          return false;
        if (!(this.l6o_1 === other.l6o_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePinInput');
    SavePinInputClass = $;
  }
  return SavePinInputClass;
}
//region block: exports
export {
  SavePinInput as SavePinInputnc3r3ek8pldn,
};
//endregion

//# sourceMappingURL=SavePinInput.mjs.map
